export const getSeasonPassOptions = () => {
    if (process.env.REACT_APP_ENV_NAME === "production") {
        return {
            seasonPassUpgradeProductId: "0e0bf6e3-8967-4d07-bd62-5e3e275dd62f",
            changeDailyTicketSeatProductId: "4f159ae6-7b7f-439c-bc5b-e23e46f751d8",
        }
    }

    return {
        seasonPassUpgradeProductId: "123",
        changeDailyTicketSeatProductId: "4f159ae6-7b7f-439c-bc5b-e23e46f751d8",
    }
}